import React from 'react'
import {MainInfoP, InfoSec, InfoImg, InfoTxt} from './InfoP.style'
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles(theme => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '76vw',
      height: 'auto',
      backgroundColor: '#F9F9F9',
      border: '5px solid #cc0145',
      color: '#fffff',
      padding:'5vw',
      justifyContent: 'center'
    },
  }));
  


export default function InfoP() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
    return (
        <div>
        
            <MainInfoP>
            <p>Smartia Markets</p>
                <InfoSec>
                    <InfoImg>
                        <img href="Percepción" src='https://res.cloudinary.com/dojodevs/image/upload/v1578161958/smartia/RECURSOS/Perception1-01_zcmoow.png'/>
                    </InfoImg>
                    <InfoTxt>
                        <h4>PERCEPCIÓN</h4>
                        <Button variant="contained" color="Primary" onClick={handleOpen}>
                            Ver más
                        </Button>
                         <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            className={classes.modal}
                            open={open}
                            onClose={handleClose}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                            timeout: 500,
                            }}
                        >
                        <Fade in={open}>
                            <div className={classes.paper}>
                            <h2 id="transition-modal-title">Percepción del producto y/o marca: </h2>
                            <p  id="transition-modal-description">Índice de sentimiento de los consumidores asociado a la marca y/o producto con información de redes sociales y otras fuentes de información. Análisis a nivel agregado y por sociodemográficos (sexo, edad, nivel de ingreso y región).
                            </p>
                            </div>
                        </Fade>
                        </Modal>
                    </InfoTxt>
                </InfoSec>
                <InfoSec>
                    <InfoImg>
                        <img href="Trending" src='https://res.cloudinary.com/dojodevs/image/upload/v1578161928/smartia/RECURSOS/Trend2-01_b39hkr.png'/> 
                    </InfoImg>
                    <InfoTxt>
                        <h4>TENDENCIAS</h4>
                        <Button variant="contained" color="Primary" onClick={handleOpen}>
                            Ver más
                        </Button>
                         <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            className={classes.modal}
                            open={open}
                            onClose={handleClose}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                            timeout: 500,
                            }}
                        >
                        <Fade in={open}>
                            <div className={classes.paper}>
                            <h2 id="transition-modal-title">Tendencias de consumo</h2>
                            <p id="transition-modal-description">Ideas asociadas en tiempo real  a la marca y/o producto con información de redes sociales y otras fuentes de información. Análisis a nivel agregado y por sociodemográficos (sexo, edad, nivel de ingreso y región).</p>
                            </div>
                        </Fade>
                        </Modal>
                    </InfoTxt>
                </InfoSec>
                <InfoSec>
                    <InfoImg>
                        <img href="Precio" src='https://res.cloudinary.com/dojodevs/image/upload/v1578161947/smartia/RECURSOS/PriceLanding1-01_skd7dg.png'/>
                    </InfoImg>
                    <InfoTxt>
                        <h4>PRECIO</h4>
                        <Button variant="contained" color="Primary" onClick={handleOpen}>
                            Ver más
                        </Button>
                         <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            className={classes.modal}
                            open={open}
                            onClose={handleClose}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                            timeout: 500,
                            }}
                        >
                        <Fade in={open}>
                            <div className={classes.paper}>
                            <h2 id="transition-modal-title">Análisis de precio y competencia</h2>
                            <p  id="transition-modal-description">Evolución y medición de impacto de los precios en la percepción de la marca y/o producto.Índice de oportunidad de negocio a nivel regional determinado por sentimiento, competencia y crecimiento.</p>
                            <img style={{height:'35vh', margin:'3vw'}} src="https://assets.highcharts.com/images/demo-thumbnails/highcharts/chart-update-default.png" alt=""/>
                            <img style={{height:'35vh', margin:'3vw'}} src="https://landing.moqups.com/img/content/charts-graphs/pie-donut-charts/user-acquisition-donut-chart/user-acquisition-donut-chart-1600.png" alt=""/>
                            </div>
                        </Fade>
                        </Modal>
                    </InfoTxt>
                </InfoSec>
            </MainInfoP>
        </div>
    )
}